/**
 * Sleutel-normalisatie voor config-objecten die ONDER een key in regels staan
 * (gemeenten, diensten). Eén bron, zodat een nieuwe gemeente-key en een nieuwe
 * dienst-key volgens exact dezelfde regels ontstaan.
 *
 * BEWUST NIET samengevoegd met maakMedewerkerSleutel (useRoosterStore.js):
 * die kapt niet af op 30 tekens en heeft een eigen open backlog-punt (auto-suffix
 * bij een dubbele naam). Samenvoegen zou dat gedrag stilzwijgend veranderen.
 *
 * Let op: de uitkomst kan leeg zijn (invoer zonder [a-z0-9_]) of met '_' beginnen
 * (invoer "_test"). Beide zijn ongeldig als config-key — regels-lezers filteren
 * '_'-keys weg als meta-veld (Beheer.jsx:44, MedewerkerModal.jsx:195). De
 * aanroeper moet daarop controleren; deze helper normaliseert alleen.
 */
export function maakSleutel(label) {
  return (label || '').toLowerCase().replace(/\s+/g, '_').replace(/[^a-z0-9_]/g, '').slice(0, 30);
}
